// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.v-application .text-overline[data-v-331eb522] {\r\n  line-height: 0 !important;\n}\n.node-col[data-v-331eb522] {\r\n  max-width: 8rem !important;\n}\n.date-col[data-v-331eb522] {\r\n  min-width: 15rem !important;\n}\r\n/*.row {\r\n  border: solid 1px red;\r\n}\r\n.col {\r\n  border: solid 1px orange;\r\n}*/\r\n", ""]);
// Exports
module.exports = exports;
